import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInfo: {
        id: 'ml.gateway.quoteandbind.pa.additionalInformation.Additional Info',
        defaultMessage: 'Additional Info',
    },
    priorInsurance: {
        id: 'ml.quoteandbind.pa.additionalInformation.Prior Insurance',
        defaultMessage: 'Prior Insurance',
    },
    driverError: {
        id: 'ml.gpa.quoteandbind.pa.additionalInformation.Driver Error',
        defaultMessage: 'Excluded Drivers or household members marked with (!) need your attention'
    },
    houseAdditionalInformation: {
        id: 'ml.gpa.quoteandbind.pa.additionalInformation.HouseAdditionalInformation',
        defaultMessage: 'Additional Information'
    },
    nextDescription: {
        id: 'ml.quoteandbind.pa.additionalInformation.nextDescription',
        defaultMessage: 'We\'ll {review} next'
    },
    reviewForAnyDrivingActivity: {
        id: 'ml.quoteandbind.pa.additionalInformation.review for any driving activity',
        defaultMessage: 'review for any driving activity'
    },
    assignmentRequiredError: {
        id: 'ml.quoteandbind.pa.additionalInformation.assignmentRequiredError',
        defaultMessage: 'One or more vehicles have not been assigned with a principal driver'
    },
    totalPercentageError: {
        id: 'ml.quoteandbind.pa.additionalInformation.totalPercentageError',
        defaultMessage: 'Total for each vehicle must equal 100'
    },
    vehiclePercentageDriverError: {
        id: 'ml.quoteandbind.pa.additionalInformation.vehicleDriverPercentageError',
        defaultMessage: 'One or more drivers have not been assigned as the highest percentage on a vehicle. Resident students do not need to be assigned as the highest percentage.'
    },
    vehiclePrimaryDriverError: {
        id: 'ml.quoteandbind.pa.additionalInformation.vehiclePrimaryDriverError',
        defaultMessage: 'One or more drivers have not been assigned as a principal driver on a vehicle. Resident students do not need to be assigned as a primary driver.'
    },
    helptext:{
        id:'ml.quoteandbind.pa.gateway.additionalInformation.What does this mean',
        defaultMessage:'What does this mean?'
    },
    helptextMap:{
        id:'ml.quoteandbind.pa.gateway.additionalInformation.newPolicySameLocation',
        defaultMessage:'You are purchasing a new policy for the same location but with different type of coverage.  For example, purchasing the home you were previously renting.'
    },
    priorInsuranceMessage: {
        "id": "ml.quoteandbind.pages.additionalinfo.Agent Prior Insurance Message",
        "defaultMessage": "The Prior Insurance information on this screen is from a prior policy with us, or from another insurance carrier’s information on a consumer report.  Any field that contains this information cannot be changed.  For questions or to dispute the information from a prior policy with us, please contact us.  For questions or to dispute information from another insurance carrier, consumers should contact the LexisNexis Consumer Service Center by phone at 800-456-6004, by mail at PO Box 105108 Atlanta, GA 30348-5108, or online at www.consumerdisclosure.com."
    },
    somethingWentWrong: {
        id:'ml.quoteandbind.pages.additionalinfo.Something went wrong during this process.  Please try again.',
        defaultMessage:"Something went wrong during this process.  Please try again."
    },
    CompanyPolicyNumber_Ext: {
        "id": "ml.quoteandbind.pages.additionalinfo.Please enter a Policy Number.",
        "defaultMessage": "Please enter a Policy Number."
    },
    TenureOriginalEffDate_Ext: {
        "id": "ml.quoteandbind.pages.additionalinfo.Please enter an Original Effective Date for the Prior Policy",
        "defaultMessage": "Please enter an Original Effective Date for the Prior Policy."
    },
    FarmersSubCompany_Ext: {
        "id": "ml.quoteandbind.pages.additionalinfo.Please Specify Company.",
        "defaultMessage": "Please Specify Company."
    },
    mvrDMVError: {
        id: 'ml.gateway.quoteandbind.pages.additionalinfo.mvrDMVError',
        defaultMessage: 'The Department of Motor Vehicles cannot process the Motor Vehicle report due to Invalid Name, Gender, DOB or License Number.  Please verify these fields.'
    },
    InvalidInsuranceProviderForBookRoll: {
        id: 'ml.quoteandbind.pages.additionalinfo.InvalidInsuranceProviderForBookRoll',
        defaultMessage: 'Prior Insurance Provider is not valid for the Book Roll Type combination'
    },
    mvrUnavailableError: {
        id: 'ml.gateway.quoteandbind.pages.additionalinfo.mvrUnavailableError',
        defaultMessage: 'Motor Vehicle Record not available at this time, please try again later.'
    }
});
